import { IoAddOutline } from "react-icons/io5";
import { useEffect, useState } from "react";
import CreateDistributor from "../../component/userManagement/distributor/createDistributor";
import EmployeeList from "../../component/userManagement/employee/employeeList";
import DistributorList from "../../component/userManagement/distributor/distributorList";
import InvestorList from "../../component/userManagement/investor/investorList";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../component/ui/tabs";
import { Button } from "../../component/ui/button";
import { Card, CardContent } from "../../component/ui/card";
import { Search } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../component/ui/dropdown-menu";
import { IoIosArrowBack, IoIosArrowDown } from "react-icons/io";
import CreateEmployee from "../../component/userManagement/employee/createEmployee";
import CreateInvestor from "../../component/userManagement/investor/createInvestor";
import { Input } from "../../component/ui/input";
import { deleteInvestor, getAllDistributorDetails, getAllEmployeeDetails, getAllInvestorDetails, getAllInvestorDetailsAssignedToEmployeeByScheme, getAllInvestorDetailsByScheme } from "../../utils/util";
import { MdOutlineDelete, MdOutlineModeEdit } from "react-icons/md";
import { FaRegEye } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loaderSet } from "../../context/actions/loaderAction";
import { nullInvestorInfo } from "../../context/actions/investorInfoAction";
import { nullDistributorInfo } from "../../context/actions/distributorInfoAction";
import { nullEmployeeInfo } from "../../context/actions/employeeInfoAction";
import Loader from "../../component/loader";
import AdvancedDropdown from "../../component/ui/multi-selection-dropdown-menu-with-search";
import { alertDanger } from "../../context/actions/toastAction";

export function UserManagement({ employee }) {
  const [activeTab,setActiveTab]=useState('employee')
  const location = useLocation()
  const [employeeDetails, setEmployeeDetails] = useState([])
  const [investorDetails, setInvestorDetails] = useState([])
  const [distributorDetails, setDistributorDetails] = useState([])
  const dispatch = useDispatch()
  const [investorCurrentPage, setInvestorCurrentPage] = useState(1)
  const [distributorCurrentPage, setDistributorCurrentPage] = useState(1)
  const [employeeCurrentPage, setEmployeeCurrentPage] = useState(1)
  const [investorTotalPage, setInvestorTotalPage] = useState(1)
  const [distributorTotalPage, setDistributorTotalPage] = useState(1)
  const [employeeTotalPage, setEmployeeTotalPage] = useState(1)
  const [isLoading, setIsLoading] = useState(false)
  const [filteredInvestorDetails, setFilteredInvestorDetails] = useState([])
  const [filteredDistributorDetails, setFilteredDistributorDetails] = useState([])
  const [filteredEmployeeDetails, setFilteredEmployeeDetails] = useState([])

  const [selectedSchemeOptions, setSelectedSchemeOptions] = useState([]);
  const [schemeAndClassOption, setSchemeAndClassOption] = useState([]);
  const allSchemeDetails = useSelector(state => state.allSchemeDetails)

  useEffect(() => {
    console.log("allSchemeDetails:", allSchemeDetails);
    if (allSchemeDetails && allSchemeDetails?.length > 0) {
      console.log("allSchemeDetails.schemes:", allSchemeDetails.schemes);
      const schemeAndClass = allSchemeDetails.flatMap((item) => {
        console.log("item:", item);
        if (Array.isArray(item.scheme_class)) {
          return item.scheme_class.map((schemeClass) => `${item.scheme_name}-${schemeClass}`);
        }
        return [];
      });
      console.log("schemeAndClass:", schemeAndClass);
      setSchemeAndClassOption(schemeAndClass);
      if (schemeAndClass?.length > 0) {
        setSelectedSchemeOptions([schemeAndClass[0]])
      }
    }
  }, [allSchemeDetails]);


  useEffect(() => {
    if (location.pathname === "/admin" || location.pathname === "/employee") {
      dispatch(nullInvestorInfo())
      dispatch(nullDistributorInfo())
      if (employee === false) { dispatch(nullEmployeeInfo()) }
    }

  },)
  const getAllEmployee = async () => {
    setIsLoading(true)
    const payload = {
      page_no: employeeCurrentPage,
      per_page: 10,
      user_type: "employee"
    }
    try {
      const response = await getAllEmployeeDetails(payload)
      if (response && response?.code === 200) {
        console.log("employee", response)
        setEmployeeDetails(response?.data.employees.filter((item, index) => item?.is_deleted === false))
        setEmployeeTotalPage(response?.data?.pagination.total_pages)
        setIsLoading(false)
      }
      else {
        setFilteredEmployeeDetails([])
        setEmployeeTotalPage(1)
        setIsLoading(false)
      }
    } catch (error) {
      console.log("Error in get investor api", error)
      setFilteredEmployeeDetails([])
      setEmployeeTotalPage(1)
      setIsLoading(false)
    }
  }
  const getAllDistributor = async () => {
    setIsLoading(true)
    const payload = {
      page_no: distributorCurrentPage,
      per_page: 10,
      user_type: "distributor"
    }
    try {
      const response = await getAllDistributorDetails(payload)
      if (response && response?.code === 200) {
        console.log("distributor", response)
        setDistributorDetails(response?.data.distributors.filter((item, index) => item?.is_deleted === false))
        setDistributorTotalPage(response?.data?.pagination.total_pages)
        setIsLoading(false)
      }
      else {
        setFilteredDistributorDetails([])
        setDistributorTotalPage(1)
        setIsLoading(false)
      }
    } catch (error) {
      console.log("Error in get investor api", error)
      setFilteredDistributorDetails([])
      setDistributorTotalPage(1)
      setIsLoading(false)
    }
  }

  const employeeInfo = useSelector(state => state.employeeInfo)


  const getAllInvestor = async () => {

    let scheme_name, scheme_class
    if (selectedSchemeOptions && selectedSchemeOptions?.length > 0) {
      scheme_class = selectedSchemeOptions[0]?.split("-")[1]
      scheme_name = selectedSchemeOptions[0]?.split("-")[0]


    }

    setIsLoading(true)
    const payload = {
      scheme_class: scheme_class,
      scheme_name: scheme_name,
      page_no: investorCurrentPage,
      per_page: 10,
      user_type: employeeInfo && employee ? "employee" : "investor",
      user_id: employeeInfo && employee ? employeeInfo?.user_id : ""

    }
    try {
      // const response = await getAllInvestorDetails(payload)
      //  const response = await getAllInvestorDetailsByScheme(payload)

      let response
      if (!employee && !employeeInfo) {
        response = await getAllInvestorDetailsByScheme(payload)
      }
      if (employee && employeeInfo && employeeInfo?.user_id) {
        response = await getAllInvestorDetailsAssignedToEmployeeByScheme(payload)
      }

      if (response && selectedSchemeOptions?.length > 0 && response?.code === 200) {
        console.log("investor", response)
        setInvestorDetails(response?.data.investors.filter((item, index) => item?.is_deleted === false))

        setInvestorTotalPage(response?.data?.pagination.total_pages)
        setIsLoading(false)
      }
      else {
        if (response?.code !== 200 && selectedSchemeOptions?.length > 0) {
          dispatch(alertDanger(response?.message))
        }

        setFilteredInvestorDetails([])
        setInvestorTotalPage(1)
        setIsLoading(false)
      }
    } catch (error) {
      console.log("Error in get investor api", error)
      setFilteredInvestorDetails([])
      setInvestorTotalPage(1)
      setIsLoading(false)
    }
  }


  useEffect(() => {
    getAllInvestor();
  }, [selectedSchemeOptions, investorCurrentPage])

  useEffect(() => {
    getAllDistributor()
  }, [distributorCurrentPage])

  useEffect(() => {
    getAllEmployee()
  }, [employeeCurrentPage])


  const handleDeleteInvestor = async () => {
    const payload = {
      "user_id": "user_456186b2",
      "user_email": "madhankumarraja6@gmail.com",
      "user_type": "employee"
    }
    try {
      const response = await deleteInvestor(payload)
      console.log("response", response)

    } catch (error) {
      console.log("Error in delete api ", error)
    }
  }

  const buttonOptions = [

  !employee &&  {
      name: "Delete",
      text: <span className="text-base font-semibold">Delete</span>,
      // action:()=>{},
      icon: <MdOutlineDelete size={20} />,
      actionDandleDeleteInvestor: handleDeleteInvestor
    },
    {
      name: "View",
      text: <span className="text-base font-semibold">View</span>,
      //  action:handleInvestorInfoId(selectedId),
      icon: <FaRegEye size={20} />
    },
    {
      name: "Edit",
      text: <span className="text-base font-semibold">Edit</span>,
      icon: <MdOutlineModeEdit size={20} />,
      // action:()=>{},
    }
  ].filter(Boolean)





  const tabsList = [
    {
      label: "Employee", value: "employee", component: location.pathname === "/admin/employee-view-user" ? <CreateEmployee setActiveTab={setActiveTab} getAllEmployee={getAllEmployee} /> : <EmployeeList getAllEmployee={getAllEmployee} totalPage={employeeTotalPage} currentPage={employeeCurrentPage} setCurrentPage={setEmployeeCurrentPage} buttonOptions={buttonOptions} employeeDetails={filteredEmployeeDetails} />
    },
    {
      label: "Distributor", value: "distributor", component: location.pathname === "/admin/distributor-view-user" ? <CreateDistributor setActiveTab={setActiveTab} getAllDistributor={getAllDistributor} /> : <DistributorList getAllDistributor={getAllDistributor} totalPage={distributorTotalPage} currentPage={employeeCurrentPage} setCurrentPage={setDistributorCurrentPage} buttonOptions={buttonOptions} distributorDetails={filteredDistributorDetails} />
    },
    {
      label: "Investor", value: "investor", component: location.pathname === "/admin/investor-view-user" ? <CreateInvestor setActiveTab={setActiveTab} getAllInvestor={getAllInvestor} /> : <InvestorList totalPage={investorTotalPage} getAllInvestor={getAllInvestor} currentPage={investorCurrentPage} setCurrentPage={setInvestorCurrentPage} buttonOptions={buttonOptions} investorDetails={filteredInvestorDetails} />
    },
  ];


  // Set initial state for createUser and userType
  const [createUser, setCreateUser] = useState(false);
  const [selectedUserType, setSelectedUserType] = useState(""); // Store selected user type
  useEffect(() => {
    dispatch(loaderSet(true))
    setInterval(() => {
      dispatch(loaderSet(false))
    }, 3000);
  }, [])
  const handleCreateUser = () => {
    setCreateUser(!createUser);
  };

  const handleSelectUserType = (type) => {
    setSelectedUserType(type);
  };

  const [searchTerm, setSearchTerm] = useState("")


  useEffect(() => {
    console.log(searchTerm)
    if (investorDetails.length > 0) {
      if (searchTerm.length > 0) {

        setFilteredInvestorDetails(investorDetails.filter((investor) => {
          const search = searchTerm.toLowerCase();
          return (
            investor.user_email.toLowerCase().includes(search) ||
            investor.name.toLowerCase().includes(search) ||
            investor.mobile_number.toString().toLowerCase().includes(search)


          );
        }))
      }
      else {
        setFilteredInvestorDetails(investorDetails)
      }
    }
    if (distributorDetails.length > 0) {
      if (searchTerm.length > 0) {

        setFilteredDistributorDetails(distributorDetails.filter((investor) => {
          const search = searchTerm.toLowerCase();
          return (
            investor.user_email.toLowerCase().includes(search) ||
            investor.name.toLowerCase().includes(search) ||
            investor.mobile_number.toString().toLowerCase().includes(search)


          );
        }))
      }
      else {
        setFilteredDistributorDetails(distributorDetails)
      }
    }
    if (employeeDetails.length > 0) {
      if (searchTerm.length > 0) {

        setFilteredEmployeeDetails(employeeDetails.filter((investor) => {
          const search = searchTerm.toLowerCase();
          return (
            investor.user_email.toLowerCase().includes(search) ||
            investor.name.toLowerCase().includes(search) ||
            investor.mobile_number.toString().toLowerCase().includes(search)


          );
        }))
      }
      else {
        setFilteredEmployeeDetails(employeeDetails)
      }
    }

  }, [searchTerm, investorDetails, employeeDetails, distributorDetails])




  return createUser ? (
    <>
      {
        isLoading && <Loader />
      }
      <div className="w-full flex flex-col p-6 bg-[#FFFFFF] rounded-md gap-8">
        <div className="flex w-full justify-between items-center gap-4">
          {/* Dropdown Menu */}
          {!employee ?
            <>

              <div className="flex flex-row w-full gap-2  items-center" >
                <div className="flex flex-col w-[49%] gap-2">
                  {/* <Label className="text-start text-[#0D215C] font-bold text-lg" htmlFor="userType">User Type</Label> */}
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button id="userType" variant="outline" size="lg" className="h-10 gap-1 w-full text-md flex border-[#3a5dd1] justify-between">
                        <span>{selectedUserType || "User Type"}</span>
                        <span className="ml-1 text-[#0D215C]"><IoIosArrowDown /></span>
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent className={"w-[var(--radix-dropdown-menu-trigger-width)]"}>
                      <DropdownMenuLabel>Select User Type</DropdownMenuLabel>
                      <DropdownMenuSeparator />
                      <DropdownMenuItem onSelect={() => handleSelectUserType("Distributor")}>
                        Distributor
                      </DropdownMenuItem>
                      <DropdownMenuItem onSelect={() => handleSelectUserType("Employee")}>
                        Employee
                      </DropdownMenuItem>
                      <DropdownMenuItem onSelect={() => handleSelectUserType("Investor")}>
                        Investor
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>

                </div>
                {/* Back Button */}
                <div className="flex flex-row  gap-2 justify-end w-full">

                  <Button
                    variant="outline"
                    size="sm"
                    className=" h-10  gap-1 text-sm w-max self-start "
                    onClick={() => {
                      setSelectedUserType("")
                      // dispatch(loaderSet(true))
                      setCreateUser(false)
                    }
                    }
                  >
                    <IoIosArrowBack />
                    Back
                  </Button>

                </div>

              </div>
            </>

            :
            <>

              <div className="flex flex-col w-[49%] gap-2">
                <Input
                  id="investor"
                  type="text"
                  value={"Investor"}
                  className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss cursor-pointer "
                  disabled={true}
                >
                </Input>



              </div>
              <Button
                variant="outline"
                size="sm"
                className=" h-10  gap-1 text-sm w-max self-start "
                onClick={() => {
                  setSelectedUserType("")
                  // dispatch(loaderSet(true))
                  setCreateUser(false)
                }
                }
              >
                <IoIosArrowBack />
                Back
              </Button>
            </>
          }

        </div>

        <div className='w-full h-2 rounded-md bg-muted'></div>
      </div>

      {/* Conditionally render the CreateDistributor component if the selected user type is Distributor */}


      {!employee ? (
        <>
          {selectedUserType === "Distributor" && <CreateDistributor setActiveTab={setActiveTab}  back={() => { setCreateUser(false) }} getAllDistributor={getAllDistributor} />}
          {selectedUserType === "Employee" && <CreateEmployee setActiveTab={setActiveTab}  back={() => { setCreateUser(false) }} getAllEmployee={getAllEmployee} />}
          {selectedUserType === "Investor" && <CreateInvestor setActiveTab={setActiveTab}  back={() => { setCreateUser(false) }} getAllInvestor={getAllInvestor} />}
        </>
      ) : (
        <CreateInvestor setActiveTab={setActiveTab} back={() => { setCreateUser(false) }} getAllInvestor={getAllInvestor} forWhichUserType={employee ? "employee" : "admin"} />
      )}


    </>
  ) : (
    // Render the user management tabbed interface
    <div className="flex min-h-screen w-full flex-col">
      {
        isLoading && <Loader />
      }
      <div className="flex flex-col sm:gap-4 sm:pl-1">
        <main className="grid flex-1 items-start gap-4">
          <div className="grid auto-rows-max items-start gap-4 md:gap-8 lg:col-span-2">
            {(location.pathname === "/admin" || location.pathname === "/employee") && <div className="flex items-center gap-2 justify-end">
              <Button
                variant="outline"
                size="lg"
                className="h-10 gap-1 text-md"
                onClick={handleCreateUser}
              >
                <span className="ml-1 text-[#0D215C]">
                  <IoAddOutline />
                </span>
                <span className="sr-only sm:not-sr-only">Add User</span>
              </Button>
            </div>}

            {/* <Tabs defaultValue={!employee ? 'employee' : 'investor'}> */}
            <Tabs value={employee ? "investor" : activeTab} onValueChange={setActiveTab}>
              <div className="flex bg-white items-center flex-col">
                <div className="flex w-full flex-col items-start mt-2">
                  {(location.pathname === "/employee" || location.pathname === "/admin") && <TabsList className="bg-white border-b-2 w-full rounded-none flex justify-start">
                    {
                      !employee ? tabsList.map((curElem, index) => (
                        <Link to="/admin" >
                          <TabsTrigger
                            key={index}
                            value={curElem.value}
                            className="data-[state=active]:text-[#0D215C] data-[state=active]:font-bold"
                            onClick={() => {
                              setActiveTab(curElem.value)
    
    
                            }}
                          >
                            {curElem.label}
                          </TabsTrigger>
                        </Link>
                      ))
                        :
                        [{ label: "Investor", value: "investor", component: <InvestorList /> }].map((curElem, index) => (
                          <TabsTrigger
                            key={index}
                            value={activeTab}
                            className="data-[state=active]:text-[#0D215C] data-[state=active]:font-bold"
                          >
                            {curElem.label}
                          </TabsTrigger>
                        ))
                    }
                  </TabsList>}
                </div>

                <div className="w-full flex justify-between items-start p-2">
                  <div className="flex w-full justify-end items-center gap-4">
                    {/* Add any additional dropdown menus or actions here */}

                    {!employee ?
                      tabsList.map((curElem, index) => (
                        <TabsContent key={index} value={curElem.value}>

                          {(location.pathname === "/employee" || location.pathname === "/admin") &&
                            <>
                              <div className="flex w-full justify-end items-center gap-4">
                                <div className="w-64 h-10">
                                  {curElem?.value === "investor" && <AdvancedDropdown
                                    name="Scheme"
                                    id="scheme"
                                    options={schemeAndClassOption}
                                    selectedOptions={selectedSchemeOptions}
                                    setSelectedOptions={setSelectedSchemeOptions}
                                    placeholder="Scheme"
                                    select={"single"}
                                    label={false}
                                  />}
                                </div>
                                <div className="flex w-96 gap-2 border-b-2 border-[#0D215C]">
                                  <Search className="h-8 w-6 text-muted-foreground" />
                                  <Input
                                    type="search"
                                    placeholder="Search..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="rounded-none border-none focus:ring-0 text-lg"
                                  />
                                </div>
                              </div>
                            </>
                          }

                        </TabsContent>
                      ))
                      :
                      [{ label: "Investor", value: "investor" }].map((curElem, index) => (
                        <TabsContent key={index} value={curElem.value}>


                          {(location.pathname === "/employee" || location.pathname === "/admin") &&
                            <>
                              <div className="flex w-full justify-end items-center gap-4">
                                <div className="w-64 h-10">
                                  <AdvancedDropdown
                                    name="Scheme"
                                    id="scheme"
                                    options={schemeAndClassOption}
                                    selectedOptions={selectedSchemeOptions}
                                    setSelectedOptions={setSelectedSchemeOptions}
                                    placeholder="Scheme"
                                    select={"single"}
                                    label={false}
                                  />
                                </div>
                                <div className="flex w-96 gap-2 border-b-2 border-[#0D215C]">
                                  <Search className="h-8 w-6 text-muted-foreground" />
                                  <Input
                                    type="search"
                                    placeholder="Search..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="rounded-none border-none focus:ring-0 text-lg"
                                  />
                                </div>
                              </div>
                            </>
                          }


                        </TabsContent>
                      ))

                    }

                    {/* { (location.pathname==="/employee" || location.pathname==="/admin") && <div className="flex w-96 gap-2 border-b-2 border-[#0D215C]">
                  <Search className="h-8 w-6 text-muted-foreground" />
                        <Input
                            type="search"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e)=>setSearchTerm(e.target.value)}
                            className="rounded-none border-none focus:ring-0 text-lg"
                        />
                    </div>} */}

                  </div>
                </div>
              </div>

              {/* Render tab content based on the selected tab */}
              {!employee ?
                tabsList.map((curElem, index) => (
                  <TabsContent key={index} value={curElem.value}>
                    <Card>
                      <CardContent>
                        <div className="w-full flex justify-center items-center text-center"></div>
                        {curElem.component}
                      </CardContent>
                    </Card>
                  </TabsContent>
                ))
                :
                [{ label: "Investor", value: "investor", component: location.pathname === "/employee/investor-view-user" ? <CreateInvestor getAllInvestor={getAllInvestor} setActiveTab={setActiveTab} forWhichUserType={employee ? "employee" : "admin"} /> : <InvestorList totalPage={investorTotalPage} currentPage={investorCurrentPage} setCurrentPage={setInvestorCurrentPage} buttonOptions={buttonOptions} isEmployeeLoggedIn={true} investorDetails={filteredInvestorDetails} /> }].map((curElem, index) => (
                  <TabsContent key={index} value={curElem.value}>
                    <Card>
                      <CardContent>
                        <div className="w-full flex justify-center items-center text-center"></div>
                        {curElem.component}
                      </CardContent>
                    </Card>
                  </TabsContent>
                ))

              }
            </Tabs>
          </div>
        </main>
      </div>
    </div>
  );
}
